import { render } from "./Euxinos.vue?vue&type=template&id=9037e9c4&scoped=true"
import script from "./Euxinos.vue?vue&type=script&lang=js"
export * from "./Euxinos.vue?vue&type=script&lang=js"

import "./Euxinos.vue?vue&type=style&index=0&id=9037e9c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9037e9c4"]])

export default __exports__